/**
 * <dealer-count> — per-country dealer-count badge on product cards (progressive enhancement).
 *
 * Whose count to show is ValerydDealer.country() (assets/dealer-context.js). On a market in a
 * dealer country, the card was server-rendered with that country's figure, and this only
 * confirms it. Anywhere else the card arrives hidden and empty. This fills it for a visitor
 * from a fallback country, and otherwise leaves it hidden. Geo failure leaves it hidden too:
 * a figure the page cannot vouch for is not shown. The counts come from the
 * `valeryd.dealer_count` product metafield, written nightly by valeryd-stock-proxy. ValerydGeo
 * resolves once per page, so a grid of cards costs at most one network call.
 *
 * Interface: data-counts (JSON {ISO2: n}) · data-dealer-country · data-dealer-geo ·
 * data-geo-endpoint · data-template ("… %COUNT% …") · data-template-one · a child
 * [data-dealer-count] that receives the text.
 */
if (!customElements.get('dealer-count')) {
  customElements.define(
    'dealer-count',
    class DealerCount extends HTMLElement {
      connectedCallback() {
        this.apply();
      }

      async apply() {
        let counts;
        try {
          counts = JSON.parse(this.dataset.counts);
        } catch (e) {
          return;
        }
        const country = window.ValerydDealer ? await window.ValerydDealer.country(this) : null;
        const count = country ? Number(counts && counts[country]) || 0 : 0;
        if (count < 1) {
          this.hidden = true;
          return;
        }
        const text = this.querySelector('[data-dealer-count]');
        if (text && count === 1 && this.dataset.templateOne) {
          text.textContent = this.dataset.templateOne;
        } else if (text) {
          // The number in bold, the words around it in the language's order.
          const [before, after] = (this.dataset.template || '%COUNT%').split('%COUNT%');
          const strong = document.createElement('strong');
          strong.textContent = String(count);
          text.replaceChildren(before || '', strong, after || '');
        }
        this.hidden = false;
      }
    }
  );
}
